export const VISIT_NAME = 'visit_trackingURL';
